export const BASE_URL = process.env.REACT_APP_API_URL || 'https://internal.bijacreative.com'
export const INSIGHT_API_URL = process.env.REACT_APP_API_URL || 'https://internal.bijacreative.com'

// Metricool/Meta snapshots land late — the latest selectable insight date is today minus this many days.
export const INSIGHT_DATA_LAG_DAYS = 3
